import { FLAGSMITH_KEYS } from './key';

/**
 * What each flag reads until Flagsmith answers, and whenever Flagsmith cannot
 * be reached. The SDK serves these as `defaultFlags`, so `useGetFlagValue`
 * resolves at once instead of waiting. Each default is the safe state: chat is
 * hidden unless Flagsmith turns it on.
 */
export const FALLBACK_FLAGS: Record<string, { enabled: boolean; value: boolean }> = {
  [FLAGSMITH_KEYS.CHAT]: { enabled: false, value: false },
};
